import { applyThemeClass } from './tokens/apply'

/**
 * Maps company uniqueId → ThemeKey.
 * Companies not listed here will receive the default theme.
 * {'company-unique-id': 'theme-key'}
 */
const companyThemeMap: Record<string, string> = {}

export function applyCompanyTheme(companyUniqueId: string): void {
  const key = companyThemeMap[companyUniqueId] ?? 'default'
  applyThemeClass(key)
}
